const $ = require('jquery');

$(document).ready(function () {
    resize();
});

function resize() {
    $('.zoom-control').on('change', function () {
        let size = $(this).val();
        let items = $('.photo-list-item').not('.item-prototype').not('[aria-hidden=true]');
        let prototype = $('.item-prototype');
        switch (size) {
            case '1':
                items.attr('class', 'photo-list-item photo-list-item--x6');
                prototype.attr('class', 'item-prototype photo-list-item photo-list-item--x6');
                break;
            case '2':
                items.attr('class', 'photo-list-item photo-list-item--x4');
                prototype.attr('class', 'item-prototype photo-list-item photo-list-item--x4');
                break;
            case '3':
                items.attr('class', 'photo-list-item photo-list-item--x3');
                prototype.attr('class', 'item-prototype photo-list-item photo-list-item--x3');
                break;
        }
    });
}
